import { FastField } from 'formik'
import { styled } from '@mui/material'

const Label = styled('label')(({ theme }) => ({
	fontSize: '.875rem',
	fontFamily: 'Work Sans,sans-serif',
	color: theme.palette.secondary.main,
	marginBottom: theme.spacing(1),
	display: 'block',
}))

const Input = styled('input')(({ theme }) => ({
	width: '400px',
	maxWidth: '100%',
	borderRadius: '.375rem',
	border: `1px solid ${theme.palette.grey[400]}`,
	padding: theme.spacing(1),
	fontFamily: 'Work Sans,sans-serif',
	'&:focus': {
		outline: 'none',
		borderColor: '#a4cafe',
		boxShadow: '0 0 0 3px rgba(164, 202, 254, .45)',
	},
}))

export default function TextField({ label, name, ...props }) {
	return (
		<FastField name={name}>
			{({ field, meta }) => (
				<>
					<Label htmlFor={name} style={{ marginBottom: 8 }}>
						{label}
						<span style={{ color: 'red', paddingLeft: 2 }}>*</span>
					</Label>
					<Input type="text" name={name} {...props} {...field} />
					{meta.touched && meta.error && (
						<div style={{ color: 'red', fontSize: 16, marginTop: 8 }}>
							{meta.error}
						</div>
					)}
				</>
			)}
		</FastField>
	)
}

